import { render } from "./StartExamModal.vue?vue&type=template&id=22b53475&scoped=true"
import script from "./StartExamModal.vue?vue&type=script&lang=js"
export * from "./StartExamModal.vue?vue&type=script&lang=js"

import "./StartExamModal.vue?vue&type=style&index=0&id=22b53475&lang=scss&scoped=true"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b53475"]])

export default __exports__